export enum StudentStatusTypeEnum {
  ACTIVE=1,
  APPROVE_WAITING=2,
  LOGIN_WAITING=3,
  NOT_APPROVED=4,
  DELETED=5
}
